<div class="multiselect-block" [ngClass]="{'all-statuses': selectedStatus?.length === pStatuses?.length}">
	<div class="multiselect-label" style="font-size: 90%; color: #b1b1b1;">
		Payment Statuses Filter
	</div>

	<p-multiSelect #multiSelect [defaultLabel]="'Payment Statuses'" [selectedItemsLabel]="'{0} statuses selected'" [options]="pStatuses" styleClass="payment-multiselect"
		[optionLabel]="'name'" [(ngModel)]="selectedStatus" [showToggleAll]="true" (onChange)="updateStatuses()"
		[filter]="false" [maxSelectedLabels]="1">
		<p-header (click)="showAll()">
			Show All
		</p-header>
	</p-multiSelect>
</div>